import React, { useEffect, useRef, useState } from "react";

// components
import { SalesCard, AppointmentCard, GroupCard } from "./Cards";

// assets
import DownArrow from "bodycodi/cmap/app/img/down.png";

// utils
import { api } from "bodycodi/cmap/app/js/api";
import { moneyFormatter } from "bodycodi/cmap/app/js/common";

const SalesDetail = ({ seqNewSettlementPayroll }: any) => {
  const wrapRef: any = useRef(null);
  const foldRef: any = useRef(null);
  const [open, setOpen] = useState(false);
  const [detail, setDetail] = useState<any>({});

  useEffect(() => {
    if (open) {
      const height = foldRef.current.offsetHeight;
      wrapRef.current.style.height = height + "px";
    } else {
      wrapRef.current.style.height = 0;
    }
  }, [open]);

  const fetchDetail = async () => {
    try {
      await api
        .get(`/payroll/settlement/payrolls/${seqNewSettlementPayroll}/commissions`)
        .then(({ data }) => {
          setDetail(data);
        });
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchDetail();
  }, []);

  return (
    <div className="popup-body no-padding each-salary-detail">
      <div className="overview">
        <div className="total">
          <span className="title">총 판매금액</span>

          <div>
            <span className="right-text">{moneyFormatter(detail?.totalRevenue)}</span>
            <img src={DownArrow} onClick={() => setOpen(!open)} className={open ? " open" : ""} />
          </div>
        </div>

        <div className="fold-wrap" ref={wrapRef}>
          <div className="fold" ref={foldRef}>
            <div>
              <span>신규</span>
              <span>{moneyFormatter(detail?.newTotalRevenue)}</span>
            </div>
            <div>
              <span>재결제</span>
              <span>{moneyFormatter(detail?.inUseTotalRevenue)}</span>
            </div>
          </div>
        </div>
      </div>

      {detail?.newSettlementCommissionList?.map((commission: any, index: number) => {
        return <SalesCard key={index} detail={commission} />;
      })}
    </div>
  );
};

const AppointmentDetail = ({ seqNewSettlementPayroll }: any) => {
  const [detail, setDetail] = useState<any>({});

  const fetchDetail = async () => {
    try {
      await api
        .get(`/payroll/settlement/payrolls/${seqNewSettlementPayroll}/orders/appointment`)
        .then(({ data }) => {
          setDetail(data);
        });
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchDetail();
  }, []);

  return (
    <div className="popup-body no-padding each-salary-detail">
      <div className="overview">
        <div className="total">
          <span className="title">총 개인레슨</span>
          <span className="right-text">{`${detail?.totalCount}건`}</span>
        </div>
      </div>

      {detail?.allowancePersonalLessonOrders?.map((order: any, index: number) => {
        return <AppointmentCard key={index} detail={order} />;
      })}
    </div>
  );
};

const GroupDetail = ({ seqNewSettlementPayroll }: any) => {
  const [detail, setDetail] = useState<any>({});

  const fetchDetail = async () => {
    try {
      await api
        .get(`/payroll/settlement/payrolls/${seqNewSettlementPayroll}/orders/class`)
        .then(({ data }) => {
          setDetail(data);
        });
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchDetail();
  }, []);

  return (
    <div className="popup-body no-padding each-salary-detail">
      <div className="overview">
        <div className="total">
          <span className="title">총 그룹수업</span>
          <span className="right-text">{`${detail.totalCount}건`}</span>
        </div>
      </div>

      {detail?.allowanceGroupLessonOrderList?.map((order: any, index: any) => {
        return <GroupCard key={index} detail={order} />;
      })}
    </div>
  );
};

export { SalesDetail, AppointmentDetail, GroupDetail };
